import { Avatar, Box, Typography } from "@mui/material";

import { makeProfileAvatarUrl } from "~utils/url";

interface SalesOwnerAvatarProps {
  userId?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  showName?: boolean;
  size?: "small" | "medium" | "large";
}

export const SalesOwnerAvatar = ({
  userId,
  firstName,
  lastName,
  showName = true,
  size = "small",
}: SalesOwnerAvatarProps) => {
  const fullName = [firstName, lastName].filter(Boolean).join(" ");
  const initials = [firstName?.[0], lastName?.[0]].filter(Boolean).join("");
  const avatarUrl = userId ? makeProfileAvatarUrl(userId) : undefined;

  const avatarSizes = {
    large: { fontSize: "1.25rem", height: 40, width: 40 },
    medium: { fontSize: "1rem", height: 32, width: 32 },
    small: { fontSize: "0.75rem", height: 24, width: 24 },
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Avatar
        src={avatarUrl}
        alt={fullName}
        sx={{
          ...avatarSizes[size],
          bgcolor: "primary.main",
        }}
      >
        {initials}
      </Avatar>
      {showName && fullName && <Typography variant={size === "large" ? "body1" : "body2"}>{fullName}</Typography>}
    </Box>
  );
};
